__turbopack_context__.v({
  "UiField": "field-module__6s7Rta__UiField",
  "UiField__error": "field-module__6s7Rta__UiField__error",
  "UiField__field": "field-module__6s7Rta__UiField__field",
  "UiField__field__disabled": "field-module__6s7Rta__UiField__field__disabled" + " " + "field-module__6s7Rta__UiField__field",
  "UiField__field__error": "field-module__6s7Rta__UiField__field__error" + " " + "field-module__6s7Rta__UiField__field",
  "UiField__label": "field-module__6s7Rta__UiField__label",
  "UiField__note": "field-module__6s7Rta__UiField__note",
  "UiIncrementField": "field-module__6s7Rta__UiIncrementField",
  "UiIncrementField__disabled": "field-module__6s7Rta__UiIncrementField__disabled" + " " + "field-module__6s7Rta__UiIncrementField",
  "UiIncrementField__number": "field-module__6s7Rta__UiIncrementField__number",
  "UiInlineSelect": "field-module__6s7Rta__UiInlineSelect",
  "UiInlineSelect__chevron": "field-module__6s7Rta__UiInlineSelect__chevron",
  "UiInlineSelect__select": "field-module__6s7Rta__UiInlineSelect__select",
});
